import { PropositionProcessingLegend} from "@services/nomos_api/entities/proposition"

export const fetchTipoTramitacaoOptions = async () => [
  { key: 'true', value: PropositionProcessingLegend.true.text },
  { key: 'false', value: PropositionProcessingLegend.false.text },
]
